var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"rounded":"","dark":""}},[_vm._v(" #"+_vm._s(_vm.hashtag.tag)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }